import React from 'react'
import { Link } from 'react-router-dom'

export const Buttons = ({ title, width = '150px', handleClick, to, href, type = 'button' }) => {
  const className = 'buttons inline-flex min-h-11 items-center justify-center rounded-lg px-4 py-[0.8rem] font-semibold text-black'
  const style = { width }

  if (to) {
    return <Link to={to} className={className} style={style}>{title}</Link>
  }

  if (href) {
    return <a href={href} className={className} style={style}>{title}</a>
  }

  return (
    <button type={type} onClick={handleClick} className={className} style={style}>
      {title}
    </button>
  )
}
